import { Badge, Table } from "react-bootstrap";

import { TRANSACTION_STATUS } from "../../../constants/transaction";
import { simpleDate } from "../../../utils/displayDate";

const TransactionRecordTable = ({ data }) => {
  const renderStatus = (status) => {
    return (
      <Badge
        // pill
        bg={status === TRANSACTION_STATUS.SUCCESS ? "success" : "warning"}
      >
        {status === TRANSACTION_STATUS.SUCCESS ? "ສຳເລັດ" : "ລໍຖ້າຢື່ນຢັນ"}
      </Badge>
    );
  };

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th>ເລກທີ່</th>
          <th>ຈຳນວນເງິນ</th>
          <th>ສະຖານະ</th>
          <th>ວັນທີ່</th>
        </tr>
      </thead>
      <tbody>
        {data?.map((t, i) => {
          return (
            <tr key={t.id}>
              <td>{i + 1}</td>
              <td>{t.transactionNo}</td>
              <td>{t.amount}</td>
              <td> {renderStatus(t.status)}</td>
              <td>{simpleDate(t.createdAt)}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default TransactionRecordTable;
